import { useCookies } from '@fergdigitalcommerce/fergy-react-components';
import { useEffect, type FunctionComponent } from 'react';
import { COOKIE_SHIPPING_ALERT_NOTIFICATION, NINETY_DAYS_EXPIRATION } from '../../../constants/cookies';
import { SUPPORT_SHIPPING_LINK } from '../../../constants/links';
import { useCustomer } from '../../../hooks/apollo/customer/customer.hooks';
import { useNotification } from '../../../hooks/notification/notification.hooks';
import { isContiguousState } from '../../../utils/location/location.utils';
import { Link } from '../link/link.component';

export const ALERT_DELAY_MS = 4000;

/*
 * Component that shows a shipping alert notification for customers in Alaska and Hawaii
 */
export const ShippingAlertNotification: FunctionComponent = () => {
	const { notifyWarning } = useNotification();
	const { getCookie, setCookie } = useCookies();
	const { data } = useCustomer();
	const customerState = data?.customer?.location.state.abbreviation;
	const hasDismissedAlert = getCookie(COOKIE_SHIPPING_ALERT_NOTIFICATION) === 'true';
	const shouldShowAlert = !hasDismissedAlert && customerState && !isContiguousState(customerState);

	useEffect(() => {
		if (shouldShowAlert) {
			// delay showing the alert to avoid competing with other notifications on location change
			const timeout = setTimeout(() => {
				notifyWarning(
					<>
						Project in Alaska or Hawaii? Click{' '}
						<Link underline={true} url={`${SUPPORT_SHIPPING_LINK}#alaska-and-hawaii-pricing-and-shipping`}>
							Here
						</Link>{' '}
						for Pricing and Shipping Details
					</>,
					0,
					() => {
						setCookie(COOKIE_SHIPPING_ALERT_NOTIFICATION, 'true', NINETY_DAYS_EXPIRATION);
					}
				);
			}, ALERT_DELAY_MS);
			return () => {
				clearTimeout(timeout);
			};
		}
		return undefined;
	}, [shouldShowAlert]);
	return null;
};
